import React from "react";
import { ArrowDown } from "lucide-react";

const Activity = () => {
  return (
    <div className="p-2 md:p-4">
      <h3 className="text-lg font-bold uppercase mb-2 pb-2 border-b border-black-40">
        Activity
      </h3>
      <p className="text-xl text-black-400 font-bold flex items-center gap-2 my-4">
        You are posting more than usual!{" "}
        <span className="w-6 h-6 rounded bg-primary-300"></span>
      </p>
      <div className="mt-16">
        <div className="relative w-[410px] h-2 bg-black-20 rounded">
          <div className="absolute top-0 left-0 h-2 w-[220px] bg-primary-300 rounded"></div>
          <span className="absolute -top-6 left-[160px] -translate-x-1/2 font-bold text-black-400 uppercase flex items-center">
            10 post/week <ArrowDown size={16} />
          </span>
        </div>
        <div className="flex justify-between text-xs font-bold text-black-600 mt-1">
          <span>Inactive</span>
          <span>Very Active</span>
        </div>
      </div>
    </div>
  );
};

export default Activity;
